import { render, staticRenderFns } from "./ScrollNum.vue?vue&type=template&id=4533c8ef&scoped=true&"
import script from "./ScrollNum.vue?vue&type=script&lang=js&"
export * from "./ScrollNum.vue?vue&type=script&lang=js&"
import style0 from "./ScrollNum.vue?vue&type=style&index=0&id=4533c8ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4533c8ef",
  null
  
)

export default component.exports